<template>

	<!-- Options card -->
	<b-col lg="4">

		<div class="single-option">
			<!-- Guarantee seal -->
			<img class="lazy single-option-gua" :data-src="guaranteeSeal" alt="Guarantee">

			<!-- Title -->
			<h3>{{ product[localVariation][0].title }}</h3>

			<!-- Image -->
			<div class="single-option-image single-option-image-0ne">
				<img v-if="imagesMounted" class="lazy" :data-src="image" :alt="product[localVariation][0].title">
			</div>

			<!-- Variations -->
			<select class="flavorSelect form-control-lg col-lg" v-if="product.length > 1" @change="selectedOptionChanged" v-model="localVariation">
				<option v-for="(variation, index) in product" :value="index" :key="index">
                    <span>{{ variation[0].flavor }} </span>
                    <span v-if="variation[0].in_stock === false">(Out of Stock)</span>
                </option>
			</select>

			<h5 class="text-center extra" v-if="product[localVariation][0].subtitle">{{ product[localVariation][0].subtitle }}</h5>

			<!-- Options -->
			<div v-if="product[localVariation].length > 1" class="checkboxes">
				<label v-for="(option, index) in product[localVariation]" :class="`au-a${index}-1`" :key="index">
					<input type="radio" :value="index" :checked="option.default" v-model="optionIndex">
					<span>{{ option.description }}</span>
				</label>
			</div>

			<!-- Pricing -->
			<div class="option-info" :class="{ 'mb-0': product[localVariation][optionIndex].restock_date }" v-for="(option, index) in product[localVariation]" :key="index">
				<div class="option-price" v-if="product[localVariation].length === 1 || index === optionIndex">
					<div class="current-price">
						<span class="price">
							<span>{{ optionPrice(option) }}</span>
							<span class="price-each" itemprop="eligibleQuantity">
                                {{ optionPriceLabel(option) }} <br><span class="you-save">SAVE <span class="save">{{ option.discount_value || calculatedSavings(option.offer) }}</span>%!</span></span>
						</span>
					</div>
					<div class="old-price">
						<span class="price">Normally <del class="red"><span class=" red">{{ option.original_price_text || option.offer.original_price_local.formatted }}</span></del></span>
					</div>
				</div>

				<!-- Purchase Button -->
                <b-button v-if="option.in_stock === false && (product[localVariation].length === 1 || index === optionIndex)" :class="classForButton(option)" style="background-color: #a9a9a9; border-color: #a9a9a9;" disabled>{{ option.button }}</b-button>
                <a v-else-if="product[localVariation].length === 1 || index === optionIndex" :class="classForButton(option)" v-on:click="sendOffer(option)">{{ option.button }}</a>

				<span v-if="customerIsEligibleForTax && (product[localVariation].length === 1 || index === optionIndex)" class="sales-tax-message">* Plus applicable sales tax</span>

                <p v-if="option.restock_date && (product[localVariation].length === 1 || index === optionIndex)" class="mt-2 mb-0 product-restock-date">{{ option.restock_date }}</p>
            </div>
		</div>

		<!-- Subscription Message -->
		<div class="option-more-info option-more-info-1" v-if="product[localVariation][optionIndex] && product[localVariation][optionIndex].sub_message">
			<p class="auto-refill">By clicking “Subscribe Now” I will be enrolled in AutoRefill and receive a new supply every month (at the price above). I can easily cancel at anytime by emailing: <a href="mailto:support@sculptnation.com">support@sculptnation.com</a></p>
		</div>
	</b-col>

</template>

<script>

	export default {
		props: {
			products: Array,
			product: Array,
			options: Object,
			activeVariation: Number,
			sendOffer: Function,
			customerIsEligibleForTax: Boolean
		},

		beforeMount() {
			this.localVariation = this.activeVariation;
		},

		data() {
			return {
				optionIndex: 0,
				imagesMounted: true,
				localVariation: 0,
			}
		},

		methods: {
			selectedOptionChanged(e) {
				const flavor = this.product[e.target.value][0].flavor;
				this.$emit('selectionUpdated', flavor);
			},

			classForButton(offer) {
				let name = "site-btn";

				if (offer.button_class) {
					name += ' ' + offer.button_class;
				}

				return name;
			},

            optionPrice(option) {
                if (option.price_text) {
                    return option.price_text;
                } else if (option.showTotalPrice) {
                    return option.offer.price_local.amount.formatted;
                } else {
                    return option.offer.unit_price_local.formatted;
                }
            },

			optionPriceLabel(option) {
			    if (option.price_label) {
			        return option.price_label;
                } else if (option.showTotalPrice) {
					return 'Today Only'
				} else {
					return '/ Per Bottle';
				}
			},

			calculatedSavings(offer) {
				let newPrice = Number(offer.price_local.amount.amount);
				let originalPrice = Number(offer.original_price_local.amount);
				return Math.floor(((originalPrice - newPrice) / originalPrice) * 100);
			},
		},

		computed: {
			guaranteeSeal() {
				if (!this.options.seal || this.options.seal === 'null' || this.options.seal === 'lifetime') {
					return this.managed('/sculptnation/img/guarantee-seal-lifetime.png');
				} else {
					return this.managed('/sculptnation/img/guarantee-seal-60.png');
				}
			},

			image() {
				return this.product[this.localVariation][0].offer.media[this.product[this.localVariation][0].image_index || 0].url;
			},

            productQuantity() {
                return this.product[this.localVariation][0].offer.products.reduce((cumm, cur) => cumm + cur.quantity, 0)
            }
		},
	}

</script>

<style lang="scss" scoped>

    .product-restock-date {
        color: #626262;
        font-weight: 700;
        font-size: 1rem;
    }

	.sales-tax-message {
		font-size: 0.6em;
		font-style: italic;
		color: grey;
		margin-top: 1em;
		margin-bottom: -10px;
	}

</style>
